import { useState, useEffect } from "react";
import Modal from "../ui/Modal";
import MainSaveButton from "../ui/components/MainSaveButton";
import { FaSignature } from "react-icons/fa";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const FirmaAccountModal = ({ open, onClose, account, onSave }) => {
  const [firma, setFirma] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setFirma(account?.firma || "");
  }, [account]);

  const handleSave = async () => {
    if (!account?.id) return;
    setSaving(true);
    try {
      await onSave(account.id, firma);
      onClose();
    } catch {
      // error handled by parent
    } finally {
      setSaving(false);
    }
  };

  if (!account) return null;

  return (
    <Modal
      activeModal={!!open}
      onClose={onClose}
      title={`Firma: ${account.nombre || account.imapUser}`}
      className="max-w-8xl"
      themeClass="bg-slate-100"
      centered
      scrollContent
    >
      <div className="flex flex-col gap-3">
        <p className="text-xs text-gray-500">
          Firma HTML que se agregará al pie de los correos enviados desde esta cuenta. Usa etiquetas como &lt;p&gt;, &lt;strong&gt;, &lt;br/&gt;, &lt;a href="..."&gt;, &lt;img src="..."&gt;, etc.
        </p>
        <div className="flex flex-row gap-4 min-h-[500px]">
          <div className="flex-1 flex flex-col min-w-0">
            <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Código HTML</span>
            <textarea
              value={firma}
              onChange={(e) => setFirma(e.target.value)}
              placeholder='<p><strong>Nombre</strong><br/>Cargo - Empresa<br/>email@ejemplo.com</p>'
              className="flex-1 w-full min-h-[180px] p-3 text-xs font-mono border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 resize-y"
              spellCheck={false}
            />
          </div>
          <div className="flex-1 flex flex-col min-w-0">
            <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Vista previa</span>
            <div
              className={`flex-1 min-h-[180px] p-3 bg-gray-50 rounded-lg border border-gray-200 text-xs prose prose-sm max-w-none text-center [&_p]:text-center [&_img]:mx-auto overflow-y-auto ${!firma.trim() ? "flex items-center justify-center text-gray-400" : ""}`}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(
                  firma.trim() || "<span class='text-gray-400'>La vista previa aparecerá aquí</span>"
                ),
              }}
            />
          </div>
        </div>
        <div className="flex justify-end mt-2">
          <MainSaveButton text="Guardar firma" onClick={handleSave} loading={saving} />
        </div>
      </div>
    </Modal>
  );
};

export default FirmaAccountModal;
